import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CartIcon from '../../../components/feature/CartIcon';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        isScrolled ? 'bg-[#0A0A0A] border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-8 py-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img
              src="https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/5b9bd2cbb4f3f977486d4a8e60efd124.jpeg"
              alt="BillPlay Apparel"
              className="h-[60px] w-auto object-contain"
            />
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/shop"
              className="text-sm font-bold text-white hover:text-gray-300 transition-colors tracking-wide"
            >
              SHOP ALL
            </Link>
            <Link
              to="/new-arrivals"
              className="text-sm font-bold text-white hover:text-gray-300 transition-colors tracking-wide"
            >
              NEW ARRIVALS
            </Link>
            <Link
              to="/apparel"
              className="text-sm font-bold text-white hover:text-gray-300 transition-colors tracking-wide"
            >
              APPAREL
            </Link>
            <Link
              to="/footwear"
              className="text-sm font-bold text-white hover:text-gray-300 transition-colors tracking-wide"
            >
              FOOTWEAR
            </Link>
            <Link
              to="/accessories"
              className="text-sm font-bold text-white hover:text-gray-300 transition-colors tracking-wide"
            >
              ACCESSORIES
            </Link>
          </div>

          {/* Cart Icon */}
          <CartIcon />
        </div>
      </div>
    </nav>
  );
}